export default function PromotionExamples() {
  const examples = [
    {
      title: 'Summer Concert Series',
      type: 'Premium Promotion',
      image: 'https://public.readdy.ai/ai/img_res/8c984e5a813d53c499af00a085538891.jpg',
      results: [
        '2,500+ event page views',
        '450 tickets sold',
        '85% attendance rate',
        'Featured in 3 newsletters'
      ],
      badge: 'FEATURED',
      badgeColor: 'emerald'
    },
    {
      title: 'Local Business Expo',
      type: 'Featured Promotion',
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20expo%20trade%20show%20with%20vendor%20booths%20displays%20and%20networking%20professionals%20in%20modern%20convention%20center%20with%20bright%20lighting%20and%20branded%20banners&width=800&height=500&seq=expo001&orientation=landscape',
      results: [
        '1,800+ event page views',
        '320 registrations',
        '45 vendor participants',
        'Homepage carousel feature'
      ],
      badge: 'PROMOTED',
      badgeColor: 'blue'
    },
    {
      title: 'Community Farmers Market',
      type: 'Basic Promotion',
      image: 'https://readdy.ai/api/search-image?query=vibrant%20farmers%20market%20with%20fresh%20produce%20colorful%20vegetables%20fruit%20stands%20and%20local%20vendors%20under%20white%20tents%20with%20shoppers%20browsing%20in%20sunny%20outdoor%20setting&width=800&height=500&seq=market001&orientation=landscape',
      results: [
        '950+ event page views',
        'Weekly recurring listing',
        'Strong local engagement',
        'Calendar placement'
      ],
      badge: 'LISTED',
      badgeColor: 'gray'
    }
  ];

  return (
    <section id="examples" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Success Stories from Local Events
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            See how Roseville event organizers have used our platform to drive attendance and engagement.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {examples.map((example) => (
            <div key={example.title} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative h-48 w-full">
                <img
                  src={example.image}
                  alt={example.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold text-white ${
                  example.badgeColor === 'emerald' ? 'bg-emerald-600' :
                  example.badgeColor === 'blue' ? 'bg-blue-600' :
                  'bg-gray-600'
                }`}>
                  {example.badge}
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{example.title}</h3>
                <div className="text-sm text-gray-500 mb-4">{example.type}</div>

                <div className="space-y-2">
                  {example.results.map((result, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <i className="ri-check-line text-emerald-600 flex-shrink-0 mt-0.5"></i>
                      <span className="text-sm text-gray-700">{result}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">Ready to promote your event?</p>
          <a
            href="#submit-form"
            className="inline-block bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap"
          >
            Get Started Now
          </a>
        </div>
      </div>
    </section>
  );
}